import dayjs from 'dayjs';

import { usePersonContext } from '@/context';

export const DateOutput = ({ date }: { date: Date | string }) => {
  const { state: personState } = usePersonContext();
  const dateFormat = personState.settings?.dateFormat || 'YYYY/MM/DD';

  return <>{dayjs(date).format(dateFormat)}</>;
};
